import script from "./EventPast.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPast.vue?vue&type=script&setup=true&lang=js"

import "./EventPast.vue?vue&type=style&index=0&id=2e083fbf&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e083fbf"]])

export default __exports__